<rappider-modal title="Edit Detail View Config"
                [(visible)]="isEditModalVisible"
                okText="Save"
                cancelText="Cancel"
                [fullScreen]="true"
                [autoClose]="modalAutoClose"
                [bodyStyle]="{ padding: '0.5rem 2.5rem 0rem 1.5rem' }"
                (okClick)="onConfigSave()"
                (cancelClick)="onCancel()"
                (afterModalOpen)="onModalAfterOpen()">
  <div class="container-fluid content-area data-detail-view-builder-container"
       style="height: 100%;">
    <as-split direction="horizontal"
              [gutterSize]="10">
      <!-- Left: Fields List -->
      <as-split-area [size]="22"
                     [minSize]="20"
                     [maxSize]="40">
        <div class="section-container">
          <div class="section-header">
            <div class="builder-header">
              <h6>Fields</h6>
            </div>
            <hr>
          </div>
          <div class="section-content">
            <rappider-data-detail-view-builder-fields [(ngModel)]="tempValue.items"
                                                (ngModelChange)="onFieldsChange($event)"
                                                (populatedDataChange)="onPopulatedDataChange($event)">
            </rappider-data-detail-view-builder-fields>
          </div>
        </div>
      </as-split-area>

      <!-- Center: Preview -->
      <as-split-area [size]="46"
                     [minSize]="30"
                     [maxSize]="65">
        <div class="section-container">
          <div class="section-header">
            <div class="builder-header">
              <h6>Preview</h6>
            </div>
            <hr>
          </div>
          <div class="section-content preview-content">
            <rappider-crud-fields-display *ngIf="getPreviewData() && previewConfig"
                                         [data]="getPreviewData()"
                                         [config]="previewConfig"
                                         [columnNumber]="previewColumnNumber">
            </rappider-crud-fields-display>
            <div *ngIf="!getPreviewData()" class="no-preview-data">
              <p>No preview data available. Add fields to see preview.</p>
            </div>

            <!-- Validation Alert -->
            <div class="builder-validation-alert">
              <rappider-alert *ngIf="validationAlertVisible"
                              [type]="validationAlertConfig.type"
                              [title]="validationAlertConfig.title"
                              [description]="validationAlertConfig.description"
                              [closeable]="validationAlertConfig.closeable"
                              [showIcon]="validationAlertConfig.showIcon"
                              class="validation-alert">
              </rappider-alert>
            </div>
          </div>
        </div>
      </as-split-area>

      <!-- Right: Settings -->
      <as-split-area [size]="32"
                     [minSize]="25"
                     [maxSize]="40">
        <div class="section-container">
          <rappider-data-detail-view-builder-settings [ngModel]="tempValue"
                                              (ngModelChange)="onSettingsChange($event)"
                                              (editJsonData)="openJsonEditorModal()"
                                              [previewColumnNumber]="previewColumnNumber"
                                              (previewColumnNumberChange)="onPreviewColumnNumberChange($event)">
          </rappider-data-detail-view-builder-settings>
        </div>
      </as-split-area>
    </as-split>
  </div>
</rappider-modal>

<rappider-button text="Edit Detail View"
                 (click)="openEditModal()"></rappider-button>

<rappider-json-editor-modal [data]="tempValue"
                            [title]="'Edit Detail View Config'"
                            [visible]="isJsonEditorModalVisible"
                            (visibleChange)="onJsonEditorVisibleChange($event)"
                            (dataChange)="onDataChange($event)">
</rappider-json-editor-modal>

